class PreorderDatepicker extends HTMLElement {
    static ATTR_KEYS = {
      eventDate: 'Event Date',
      delayedDelivery: 'Pre-Order Delivery',
      despatchDate: 'Despatch Date',
      despatchDateText: 'Despatch Date in words'
    };
    connectedCallback() {
      this.waitForFlatpickr();
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
    }
  
    waitForFlatpickr() {
      if (typeof flatpickr === 'undefined') {
        setTimeout(() => this.waitForFlatpickr(), 50);
        return;
      }
  
      this.init();
    }
  
    init() {
      this.setupElements();
      this.initDatepicker();

      this.saveAttributesToCart = debounce(this.saveAttributesToCart.bind(this), 300);

      this.setupEventListeners();
      this.updateInitialState();
    }
  
    setupElements() {
      this.datePicker = this.querySelector("#calendar");
      this.checkbox = this.querySelector("#delayed_dispatch_checkbox");
      this.hiddenDelayedInput = this.querySelector("#delayed_dispatch_input");
      this.delayedSection = this.querySelector(".dispatch__delayed-section");
      this.dateSection = this.querySelector(".dispatch__date-section");
      this.despatchDateInput = this.querySelector("#edd_date");
      this.despatchDateTextInput = this.querySelector("#edd_date_text");
      this.preOrderDate = this.querySelector(".preorder__date");
    }
  
    initDatepicker() {
      this.fp = flatpickr(this.datePicker, {
        minDate: "today",
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "d/m/Y",
        disableMobile: true,
        onChange: this.handleDateChange.bind(this)
      });
    }
  
    setupEventListeners() {
      this.checkbox.addEventListener("change", () => {
        this.hiddenDelayedInput.value = this.checkbox.checked ? "Yes" : "No";
        this.toggleVisibility(this.dateSection, this.checkbox.checked);
  
        if (!this.checkbox.checked) {
          this.clearDespatchDate();
        } else {
          const eventDate = this.fp.selectedDates[0];
          if (eventDate) {
            this.calculateDespatchDate(eventDate);
          }
        }
  
        this.saveAttributesToCart();
      });
    }
  
    updateInitialState() {
      const isChecked = this.checkbox.checked;
    
      this.hiddenDelayedInput.value = isChecked ? "Yes" : "No";
    
      // ✅ Always show the checkbox section if it's checked
      this.toggleVisibility(this.delayedSection, isChecked);
    
      // ✅ Show or hide the despatch date section
      this.toggleVisibility(this.dateSection, isChecked);
    
      if (!isChecked) {
        this.clearDespatchDate();
      } else {
        const eventDate = this.fp.selectedDates[0];
        if (eventDate) {
          this.calculateDespatchDate(eventDate);
        }
      }
    }
  
    toggleVisibility(element, isVisible) {
      if (isVisible) {
        element.classList.add('dispatch__delayed-section--visible');
      } else {
        element.classList.remove('dispatch__delayed-section--visible');
      }
    }
  
    handleDateChange(selectedDates, dateStr) {
      if (!selectedDates.length) return;
  
      const selectedDate = selectedDates[0];
      this.updateEventDate(selectedDate);
  
      const now = new Date();
      const plus2Months = new Date(now.getFullYear(), now.getMonth() + 2, now.getDate());
  
      if (selectedDate > plus2Months) {
        this.toggleVisibility(this.delayedSection, true);
  
        if (this.checkbox.checked) {
          this.calculateDespatchDate(selectedDate);
          this.toggleVisibility(this.dateSection, true);
        } else {
          this.toggleVisibility(this.dateSection, false);
        }
      } else {
        this.toggleVisibility(this.delayedSection, false);
        this.toggleVisibility(this.dateSection, false);
        this.checkbox.checked = false;
        this.hiddenDelayedInput.value = "No";
        this.clearDespatchDate();
      }
  
      this.saveAttributesToCart();
    }
  
    updateEventDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      this.eventDate = `${day}/${month}/${year}`;
    }
  
    calculateDespatchDate(eventDate) {
      let despatchDate = new Date(eventDate);
      despatchDate.setDate(despatchDate.getDate() - 28);
      const dayOfWeek = despatchDate.getDay();
      if (dayOfWeek !== 1) {
        const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
        despatchDate.setDate(despatchDate.getDate() - daysToSubtract);
      }
  
      this.updateDespatchDateInputs(despatchDate);
    }
  
    updateDespatchDateInputs(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
  
      this.dispatchDate = `${day}/${month}/${year}`;
      this.dispatchDateText = date.toDateString();
  
      this.despatchDateInput.value = this.dispatchDate;
      this.despatchDateTextInput.value = this.dispatchDateText;
  
      //const label = this.querySelector(".delayed_dispatch__date");
      if (this.preOrderDate) this.preOrderDate.textContent = this.dispatchDateText;
    }
  
    clearDespatchDate() {
      this.dispatchDate = '';
      this.dispatchDateText = '';
      this.despatchDateInput.value = '';
      this.despatchDateTextInput.value = '';
  
      //const label = this.querySelector(".delayed_dispatch__date");
      if (this.preOrderDate) this.preOrderDate.textContent = '';
    }

    saveAttributesToCart() {
      const keys = PreorderDatepicker.ATTR_KEYS;
    
      const eventDate = this.datePicker.value;
      const delayedDelivery = this.hiddenDelayedInput.value;
      const despatchDate = this.despatchDateInput.value;
      const despatchDateText = this.despatchDateTextInput.value;
    
      const step1 = {
        attributes: {
          [keys.eventDate]: eventDate,
          [keys.delayedDelivery]: delayedDelivery
        }
      };
    
      const step2 = {
        attributes: {
          [keys.despatchDate]: despatchDate,
          [keys.despatchDateText]: despatchDateText
        }
      };
    
      // --- STEP 1: Save Event Date + Delayed Delivery
      fetch(theme.routes.cartUpdate, {
        ...this.fetchRequestOpts,
        body: JSON.stringify(step1)
      })
        .then(res => res.ok ? res.json() : Promise.reject(res))
        .then(data => {
          console.log('[Step 1] Attributes updated:', data.attributes);
    
          // --- STEP 2: Wait 500ms, then update Despatch Date fields
          setTimeout(() => {
            fetch(theme.routes.cartUpdate, {
              ...this.fetchRequestOpts,
              body: JSON.stringify(step2)
            })
              .then(res => res.ok ? res.json() : Promise.reject(res))
              .then(data => {
                console.log('[Step 2] Despatch date attributes updated:', data.attributes);
                document.dispatchEvent(new CustomEvent('on:cart:change'));
    
                // --- STEP 3: Verify with /cart.js and retry if needed
                setTimeout(() => this.verifyAttributes({
                  [keys.eventDate]: eventDate,
                  [keys.delayedDelivery]: delayedDelivery,
                  [keys.despatchDate]: despatchDate,
                  [keys.despatchDateText]: despatchDateText
                }), 300);
              })
              .catch(err => console.error('[Step 2] Failed:', err));
          }, 500);
        })
        .catch(err => console.error('[Step 1] Failed:', err));
    }


    verifyAttributes(expectedAttrs) {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const actualAttrs = cart.attributes || {};
          let needsRetry = false;
    
          for (const key in expectedAttrs) {
            if (expectedAttrs[key] !== actualAttrs[key]) {
              console.warn(`[VERIFY] Mismatch on "${key}": expected "${expectedAttrs[key]}", got "${actualAttrs[key]}"`);
              needsRetry = true;
            }
          }
    
          if (needsRetry) {
            console.warn('[VERIFY] Re-attempting full attribute sync...');
            fetch(theme.routes.cartUpdate, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ attributes: expectedAttrs })
            })
              .then(r => r.ok ? r.json() : Promise.reject(r))
              .then(data => console.log('[VERIFY] Retry successful:', data.attributes))
              .catch(err => console.error('[VERIFY] Retry failed:', err));
          } else {
            console.log('[VERIFY] All attributes match.');
          }
        })
        .catch(err => console.error('[VERIFY] Failed to fetch cart:', err));
    }
  }
  
customElements.define('preorder-datepicker', PreorderDatepicker);